<template>
  <div class="organization-report">
    <h1>Organization Report</h1>
    <h2>Organization: {{ organization.legalName }}</h2>
    <h4>Period od {{ formatDate(orderFrom) }} do {{ formatDate(orderTo) }}</h4>

    <!-- Display Report Data -->
    <h3>Fiksne Naknade</h3>
    <table>
      <thead>
        <tr>
          <th>Događaj</th>
          <th>Organizator</th>
          <th>Cijena Naknade (€)</th>
          <th>Količina online + offline</th>
          <th>Količina online</th>
          <th>Količina offline</th>
          <th>Ukupno Naknada (€)</th>
          <th>PDV na Naknadu (€)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in reportData" :key="item.eventId">
          <td>{{ item.eventTitle }}</td>
          <td>{{ item.organization }}</td>
          <td>
            {{
              formatCurrency(
                item.totalCoreEventEarningsWithoutVat / item.coreEventFeeTicketCount || 0,
              )
            }}
          </td>
          <td>{{ item.ticketCount }}</td>
          <td>{{ item.online }}</td>
          <td>{{ item.offline }}</td>
          <td>{{ formatCurrency(item.totalCoreEventEarningsWithoutVat) }}</td>
          <td>{{ formatCurrency(item.totalCoreEventEarningsWithoutVat * 0.25) }}</td>
        </tr>
      </tbody>
    </table>
    <!-- For example, display purchase summaries -->
    <h3>Postoci od ulaznica</h3>
    <table>
      <thead>
        <tr>
          <th>Event</th>
          <th>Sold Count</th>
          <th>Total Sold Amount (€)</th>
          <th>Total CoreEvent Fee (€)</th>
          <th>Total CoreEvent Fee with VAT (€)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="summary in purchaseSummaries" :key="summary.event.id">
          <td>{{ summary.event.title }}</td>
          <td>{{ summary.totalSoldCount }}</td>
          <td>{{ formatCurrency(summary.totalSoldAmount) }}</td>
          <td>{{ formatCurrency(summary.totalCoreEventFee) }}</td>
          <td>{{ formatCurrency(summary.totalCoreEventFeeWithVAT) }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Display Totals -->
    <div class="totals">
      <h3>
        <span>Fiksne Naknade:</span>
        <span>{{ formatCurrency(totalCoreEventFixedFeeEarnings) }} €</span>
      </h3>
      <h3>
        <span>Naknade Postotak Od Ulaznica:</span>
        <span>{{ formatCurrency(totalCoreEventEarnings - totalCoreEventFixedFeeEarnings) }} €</span>
      </h3>
      <h3>
        <span>Ukupno Naknada:</span>
        <span>{{ formatCurrency(totalCoreEventEarnings) }} €</span>
      </h3>
      <h3>
        <span>Ukupno PDV na Naknade:</span>
        <span>{{ formatCurrency(totalCoreEventEarnings * 0.25) }} €</span>
      </h3>
      <hr />
      <h3>
        <span>Ukupno Naknada s PDV-om:</span>
        <span>{{ formatCurrency(totalCoreEventEarnings * 1.25) }} €</span>
      </h3>
      <hr style="margin: 30px 0" />
      <h3>
        <span>Ukupan prihod organizatora {{ organization.legalName }}</span>
        <span>{{ formatCurrency(totalOrganizerEarnings) }} €</span>
      </h3>
      <h3>
        <span>Ukupan prihod organizatora na vlastitoj blagajni</span>
        <span>{{ formatCurrency(totalClientsCashRegisterSale) }} €</span>
      </h3>
      <h3>
        <span
          >Za isplatu:<br />
          (prihod - (naknade od postotaka + pdv) - prihod na vlastitoj blagajni - (povrati *
          2,5%))</span
        >
        <span>{{ formatCurrency(amountToPay) }} €</span>
      </h3>
    </div>

    <!-- Prikaz QR koda za isplatu -->
    <div class="payment-section">
      <h3>Uplata</h3>
      <canvas id="paymentQR"></canvas>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'

export default {
  name: 'organization-report',
  data() {
    return {
      organizationSlug: '',
      organizationName: '',
      orderFrom: '',
      orderTo: '',
      purchaseSummaries: [],
      totalCoreEventEarnings: 0,
      totalClientsCashRegisterSale: 0,
      totalOrganizerEarnings: 0,
      totalCoreEventFixedFeeEarnings: 0,
      organization: {},
      refundInfo: null,
      reportData: [],
      amountToPay: 0, // Dodali smo ovu varijablu za iznos koji treba isplatiti
    }
  },
  mounted() {
    if (window.BarcodePayment) {
      return
    }
    let barcodeScript = document.createElement('script')
    let jqueryScript = document.createElement('script')
    let pdfScript = document.createElement('script')
    let bcMathScript = document.createElement('script')

    jqueryScript.setAttribute('src', 'https://code.jquery.com/jquery-latest.min.js')
    bcMathScript.setAttribute(
      'src',
      'https://bikonja.github.io/generator-barkoda-uplatnica/bcmath-min.js',
    )
    document.head.appendChild(jqueryScript)
    document.head.appendChild(bcMathScript)

    setTimeout(() => {
      barcodeScript.setAttribute(
        'src',
        'https://rawgit.com/Bikonja/generator-barkoda-uplatnica/master/BarcodePayment.js',
      )
      pdfScript.setAttribute(
        'src',
        'https://bikonja.github.io/generator-barkoda-uplatnica/pdf417-min.js',
      )
      document.head.appendChild(barcodeScript)
      document.head.appendChild(pdfScript)
    }, 500)
  },
  created() {
    this.organizationSlug = this.$route.params.organizationSlug
    this.organizationName = this.getOrganizationName(this.organizationSlug)
    this.orderFrom = new Date(decodeURIComponent(this.$route.query.from))
    this.orderTo = new Date(decodeURIComponent(this.$route.query.to))
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY')
    },
    formatCurrency(value) {
      return parseFloat(value).toFixed(2)
    },
    getOrganizationName(slug) {
      return slug.replace(/-/g, ' ').toUpperCase()
    },
    async generatePaymentQR() {
      let count = 1
      while (count < 10) {
        count++
        if (window.BarcodePayment && window.PDF417) {
          break
        }
        await new Promise(r => setTimeout(r, 100))
      }
      window.BarcodePayment.Init({
        ValidateIBAN: false,
        ValidateModelPozivNaBroj: false,
      })

      // Calculate the amount to be paid
      const totalCoreEventPercentageFee =
        this.totalCoreEventEarnings - this.totalCoreEventFixedFeeEarnings
      const totalFeeWithVAT = totalCoreEventPercentageFee * 1.25
      const amount =
        this.totalOrganizerEarnings -
        totalFeeWithVAT -
        this.totalClientsCashRegisterSale -
        this.refundInfo.amount -
        this.refundInfo.coreEventRefundFee
      this.amountToPay = amount // Store amount for display in totals

      // Format amount with comma as decimal separator
      const amountFormatted = amount.toFixed(2).replace('.', ',')

      // Payment description
      const paymentDescription = `Uplata ${this.formatDate(this.orderFrom)} do ${this.formatDate(
        this.orderTo,
      )}`

      // Reference number (today's date in format DDMMYYYY)
      const referenceNumber = moment().format('DDMMYYYY')
      // Prepare payment parameters
      const paymentParams = new window.BarcodePayment.PaymentParams()

      paymentParams.Iznos = amountFormatted
      paymentParams.ImePlatitelja = ''
      paymentParams.AdresaPlatitelja = ''
      paymentParams.SjedistePlatitelja = ''
      paymentParams.Primatelj = ''
      paymentParams.AdresaPrimatelja = ''
      paymentParams.SjedistePrimatelja = ''
      paymentParams.IBAN = this.organization.IBAN
      paymentParams.ModelPlacanja = '00'
      paymentParams.PozivNaBroj = referenceNumber
      paymentParams.SifraNamjene = ''
      paymentParams.OpisPlacanja = paymentDescription

      // Encode payment parameters
      const textToEncode = window.BarcodePayment.GetEncodedText(paymentParams)

      if (
        textToEncode === window.BarcodePayment.ResultCode.InvalidContent ||
        textToEncode === window.BarcodePayment.ResultCode.InvalidObject ||
        !textToEncode
      ) {
        console.error('Invalid content for barcode generation')
        return
      }

      // Generate the barcode
      window.PDF417.init(textToEncode)
      const barcode = window.PDF417.getBarcodeArray()
      // Prepare the canvas
      const canvas = document.getElementById('paymentQR')
      const ctx = canvas.getContext('2d')

      const moduleWidth = 2
      const moduleHeight = 2

      canvas.width = barcode.num_cols * moduleWidth
      canvas.height = barcode.num_rows * moduleHeight

      ctx.clearRect(0, 0, canvas.width, canvas.height)

      ctx.fillStyle = 'black'

      for (let row = 0; row < barcode.num_rows; row++) {
        for (let col = 0; col < barcode.num_cols; col++) {
          if (barcode.bcode[row][col] === '1') {
            ctx.fillRect(col * moduleWidth, row * moduleHeight, moduleWidth, moduleHeight)
          }
        }
      }
    },
  },
  apollo: {
    getOrganizerReport: {
      query: gql`
        query getOrganizerReport(
          $organizationSlug: String!
          $orderFrom: DateTime!
          $orderTo: DateTime!
        ) {
          getOrganizerReport(
            organizationSlug: $organizationSlug
            orderFrom: $orderFrom
            orderTo: $orderTo
          )
        }
      `,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
          orderFrom: this.orderFrom,
          orderTo: this.orderTo,
        }
      },
      result({ data }) {
        if (data && data.getOrganizerReport) {
          const report = data.getOrganizerReport
          this.reportData = report.reportData
          this.totalOrganizerEarnings = report.totalOrganizerEarnings
          this.organization = report.organization
          this.totalClientsCashRegisterSale = report.totalClientsCashRegisterSale
          this.purchaseSummaries = report.purchaseSummaries
          this.totalCoreEventEarnings = report.totalCoreEventEarnings
          this.totalCoreEventFixedFeeEarnings = report.totalCoreEventFixedFeeEarnings
          this.refundInfo = report.refundInfo

          this.$nextTick(() => {
            this.generatePaymentQR()
          })
        }
      },
    },
  },
}
</script>

<style scoped>
rect {
  fill: black;
}

.organization-report {
  background: white;
  max-width: 21cm;
  margin: auto;
  display: block;
}

@media print {
  .payment-section {
    display: none !important;
  }
}

.totals {
  align-self: end;
}

.totals > h3 > span:nth-of-type(2) {
  float: right;
  margin-left: 10px;
}

/* Center tables for demo */
table {
}

/* Default Table Style */
table {
  color: #333;
  background: white;
  border: 1px solid grey;
  font-size: 12pt;
  border-collapse: collapse;
}

table thead th,
table tfoot th {
  color: #777;
  background: rgba(0, 0, 0, 0.1);
}

table caption {
  padding: 0.5em;
}

table th,
table td {
  padding: 0.5em;
  border: 1px solid lightgrey;
}

/* Zebra Table Style */
[data-table-theme*='zebra'] tbody tr:nth-of-type(odd) {
  background: rgba(0, 0, 0, 0.05);
}

[data-table-theme*='zebra'][data-table-theme*='dark'] tbody tr:nth-of-type(odd) {
  background: rgba(255, 255, 255, 0.05);
}

/* Dark Style */
[data-table-theme*='dark'] {
  color: #ddd;
  background: #333;
  font-size: 12pt;
  border-collapse: collapse;
}

[data-table-theme*='dark'] thead th,
[data-table-theme*='dark'] tfoot th {
  color: #aaa;
  background: rgba(0255, 255, 255, 0.15);
}

[data-table-theme*='dark'] caption {
  padding: 0.5em;
}

[data-table-theme*='dark'] th,
[data-table-theme*='dark'] td {
  padding: 0.5em;
  border: 1px solid grey;
}

.payment-section {
  margin-top: 30px;
}

#paymentQR {
  max-width: 300px;
  max-height: 300px;
}
</style>
